import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css'
import { GeomanControls } from 'react-leaflet-geoman-v2'
import { useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useMap } from 'react-leaflet';

export function DrawControls(props: any) {
    const { show, hexColor = '#eef205', onLayerEdited = (geojson) => { }, onLayerDeleted = (id) => { }, ...rest } = props;

    const { i18n } = useTranslation();
    const map = useMap();
    useEffect(() => {
        map.pm.setLang(i18n.language);
    }, [i18n.language]);

    // Need to get the color to the callback somehow.
    const colorRef = useRef(hexColor);
    colorRef.current = hexColor;

    const controls = useMemo(() => {
        var add_props_and_id = function (layer) {
            let feature = layer.feature = layer.feature || {};
            feature.type = feature.type || "Feature";
            let props = feature.properties = feature.properties || {};
            props.id = crypto.randomUUID();
            props.color = colorRef.current;
            return props
        };
    
        const onCreate = (e: any) => {
            add_props_and_id(e.layer);
            console.log('onCreate', e.layer.toGeoJSON());
            // Use setTimeout to prevent React render warnings
            setTimeout(() => {
                onLayerEdited(e.layer.toGeoJSON());
            }, 0);
            // Remove the Geoman layer - server will send back the canonical version
            e.layer.remove();
        };
        const onUpdate = (e: any) => {
            console.log('onUpdate', e.layer.toGeoJSON());
            // Use setTimeout to prevent React render warnings
            setTimeout(() => {
                onLayerEdited(e.layer.toGeoJSON());
            }, 0);
            // Remove the Geoman layer - server will send back the canonical version  
            e.layer.remove();
        };
        const onDelete = (e: any) => {
            const layer_id = e.layer.feature.properties.id;
            // Use setTimeout to prevent React render warnings
            setTimeout(() => {
                onLayerDeleted(layer_id);
            }, 0);
            console.log('onDelete', layer_id);
        };

        return <GeomanControls
            options={{
                drawText: false,
                drawCircle: false,
                drawCircleMarker: false,
                rotateMode: false,
                cutPolygon: false,
            }}
            globalOptions={{
                continueDrawing: true,
                editable: true,
            }}
            onCreate={onCreate}
            onUpdate={onUpdate}
            onLayerRemove={onDelete}
            lang={i18n.language}
        />
    }, [])

    map.pm.setGlobalOptions({
        templineStyle: {
            color: hexColor,
        },
        pathOptions: {
            color: hexColor,
        }   
    })

    if (show != map.pm.controlsVisible() ) {
        map.pm.toggleControls()
    }

    return controls
}
